import styled from '@emotion/styled'
import { colors, font } from '@mobi/component-library/Foundations'

export const TrayArticleStyled = styled.article({
  'section:nth-of-type(1)': {
    height: '9.31rem',
    width: '100%',
    backgroundColor: colors.success[50],
    textAlign: 'center',
    borderRadius: '0.8rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  'div:nth-of-type(1)': {
    width: '100%',
    height: '1.6rem',
  },

  p: {
    textAlign: 'left',
    width: '100%',
    fontSize: font.size.lg.fontSize,
    lineHeight: font.size.lg.lineHeight,
    fontFamily: font.family.primary,
    color: colors.neutral[900],
  },
})
